import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {QUESTION_VALIDATORS} from '../../../../constants/validators';
import {QuestionService} from '../../../services/api/question.service';
import {FormBuilder} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {QuestionType} from '../../../data/models/questionType';
import {QuestionTypeService} from '../../../services/api/question-type.service';
import {Question} from "../../../data/models/test/question";
import {QUESTION_TYPES} from 'src/constants/questionTypes';

@Component({
  selector: 'app-question-create-dialog',
  templateUrl: './question-create-dialog.component.html',
  styleUrls: ['./question-create-dialog.component.css']
})
export class QuestionCreateDialogComponent implements OnInit {

  readonly QUESTION_TYPES = QUESTION_TYPES;

  questionForm = this.fb.group({
    text: ['', QUESTION_VALIDATORS.TEXT],
    type: [null, QUESTION_VALIDATORS.TYPE],
    category: [null],
    minAnswers: [null, QUESTION_VALIDATORS.MIN_ANSWERS],
    maxAnswers: [null, QUESTION_VALIDATORS.MAX_ANSWERS],
  }, {validators: [QUESTION_VALIDATORS.MIN_MAX_RANGE('minAnswers', 'maxAnswers')]});

  questionTypes: QuestionType[] = [];
  testId: number;
  position: number;
  testType: string;
  categories: Map<string, string> = new Map<string, string>();

  constructor(
    private questionTypeService: QuestionTypeService,
    private questionService: QuestionService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<QuestionCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { testId: number, position: number, testType: string },
  ) {
    this.testId = this.data.testId;
    this.position = this.data.position;
    this.testType = this.data.testType;
  }

  ngOnInit(): void {
    this.getQuestionTypes();
    this.getQuestionCategories();
    this.questionForm.controls.type.valueChanges
      .subscribe(() => this.onQuestionTypeChange());
    this.onQuestionTypeChange();
  }

  getQuestionTypes(): void {
    this.questionTypeService.questionTypes$
      .subscribe(questionTypes => {
        this.questionTypes = questionTypes;
        this.onQuestionTypeChange();
      });
  }

    getQuestionCategories(): void {
        this.questionTypeService.questionCategories$
            .subscribe(questionCategories => this.categories = questionCategories);
    }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.testType === 'ISTQB') {
        this.questionForm.controls.type.setValue("1");
    }
    if (this.questionForm.valid) {
      const multipleAnswerSelected = this.isMultipleAnswerSelected();
      const minAnswers = this.getControlNumberValue('minAnswers');
      const maxAnswers = this.getControlNumberValue('maxAnswers');
      this.questionService.addQuestion(this.testId, this.position, {
        typeId: this.questionForm.controls.type.value,
        text: this.questionForm.controls.text.value,
        category: this.questionForm.controls.category.value,
        imageFile: this.imageFile,
        minAnswers: multipleAnswerSelected ? minAnswers : undefined,
        maxAnswers: multipleAnswerSelected ? maxAnswers : undefined,
      })
        .then(question => {
          this.dialogRef.close(question);
          if (this.imageFile) {
              this.loadImage(question);
          }
        });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  imageFile: File | undefined;
  url: String | undefined;
  @ViewChild('imageInput') imageInput!: ElementRef;

  uploadImageFile(imageInput: any) {
      const file: File = imageInput.files[0];
      const reader = new FileReader();

      reader.addEventListener('load', (event: any) => {
          this.url = event.target.result;
      });

      reader.readAsDataURL(file);
      this.imageFile = file;
  }

  deleteLoadedImage() {
    this.imageFile = undefined;
    this.url = undefined;
    this.imageInput.nativeElement.value = null;
  }

  private loadImage(question: Question) {
      this.questionService.getImage(question.imageName)
          .subscribe(image => {this.createImage(image, question);})
  }

  private onQuestionTypeChange(): void {
    if (!this.isMultipleAnswerSelected()) {
      this.resetMinMaxControls();
    }
  }

  isMultipleAnswerSelected(): boolean {
    const selectedTypeId = this.questionForm.controls.type.value;
    if (selectedTypeId === null || selectedTypeId === undefined) {
      return false;
    }

    const typeIdAsNumber = Number(selectedTypeId);
    const selectedType = this.questionTypes.find(type => type.id === typeIdAsNumber);
    return selectedType ? selectedType.techId === QUESTION_TYPES.MULTIPLE_ANSWER : false;
  }

  private resetMinMaxControls(): void {
    this.questionForm.controls.minAnswers.setValue(null);
    this.questionForm.controls.maxAnswers.setValue(null);
    this.questionForm.controls.minAnswers.updateValueAndValidity({emitEvent: false});
    this.questionForm.controls.maxAnswers.updateValueAndValidity({emitEvent: false});
    this.questionForm.updateValueAndValidity({onlySelf: false, emitEvent: false});
  }

  private getControlNumberValue(controlName: 'minAnswers' | 'maxAnswers'): number | undefined {
    const value = this.questionForm.controls[controlName].value;
    if (value === null || value === undefined || value === '') {
      return undefined;
    }
    const parsedValue = Number(value);
    return Number.isNaN(parsedValue) ? undefined : parsedValue;
  }

  private createImage(image: Blob, question: Question) {
      if (image && image.size > 0) {
          const reader = new FileReader();

          reader.addEventListener("load", () => {
                question.imageFile = reader.result;
            }, false);

            reader.readAsDataURL(image);
        }
    }

}